export default function headerGreen() {
    if(document.querySelector(".header--green")) {
        const header = document.querySelector(".main-header");

        header.classList.add("bg--green");
    } else {
        const header = document.querySelector(".main-header");
        const menuMobile = document.querySelector(".main-menu-mobile");
        const burgerButton = document.querySelector(".main-header__mobile-controls");

        burgerButton.addEventListener("click", () => {
            if(menuMobile.classList.contains("is-active")) {
                header.classList.add("bg--green");
            } else {
                header.classList.remove("bg--green");
            }
        });
    }
}